import axios from "axios";
import { swart } from "./baserURL";
export default function request(confing) {
  return new Promise((resove, errafi) => {
    const instance = axios.create({
      baseURL: swart,
    });
    // 设置请求头
    // instance.defaults.headers.post['content-type'] = 'application/x-www-form-urlencoded';
    // 响应拦截
    instance.interceptors.response.use((confing) => {
      // console.log(confing)
      return confing.data;
    });
    // 请求拦截
    instance.interceptors.request.use((confing) => {
      let appid = sessionStorage.getItem("token");

      const lang_file = sessionStorage.getItem("lang_file");

      //拦截token
      if (confing.params) {
        confing.params.appid = appid;
        confing.params.lang_file = lang_file;
      } else {
        confing.data.lang_file = lang_file;
        confing.data.appid = appid;
      }

      return confing;
    });
    instance(confing)
      .then((res) => {
        // console.log(res)
        resove(res);
      })
      .catch((err) => {
        errafi(err);
      });
  });
}
